import React, { useEffect } from "react";
import { Context } from "../../../../Store";
import {
  getProgramListRefreshToggle,
  getProgramsList,
  isProgramsListLoaded,
} from "../../../../Store/ProgramsList/accessors";
import {
  refreshProgramList,
  setProgramList,
  setProgramListAsLoading,
} from "../../../../Store/ProgramsList/actions";
import callAPI from "../../../../api/apiCaller";
import Button from "../../../../common/Button";
import { ButtonSpacer } from "../../../../common/Button/styles";
import Labelize from "../../../../common/Labelize";
import Loading from "../../../../common/Loading";
import Modal from "../../../../common/Modal";
import SearchTextInput from "../../../../common/TextInput/SearchTextInput";
import TextInput from "../../../../common/TextInput";
import { validateUrl } from "../../../../common/utils";
import { SectionActions } from "../../Profile/LoginSecurity/styles";
import AddProgram from "../popups/AddProgram";
import AddFolder from "./AddFolder";
import ProgramsListSection from "./ProgramsListSection";
import { getUserInfo } from "../../../../Store/User/accessors";
import EditImage from "./edit.png";
import DropdownImage from "./dropdown.png";
import {
  Image,
  CrossButtonContainer,
  CrossButtonContainerSpan,
  HeaderLine,
  JoinPorgramContainer,
  ListActions,
  ProgramSections,
  ProgramsListContainer,
  ProgramsListHeader,
  JoinButton,
  Buttons,
  SampleFolderOuter,
  FolderDropDown,
  Text,
  FolderOptions,
  EditDeleteOption,
  OpenCloseOption,
  ViewWrapper,
  CollapseButton,
} from "./styles";
import Add from "./add.png";
import Folder from "./folder.png";
import Tooltip from "../../../../common/Tooltip";
import Icon from "../../../../common/Icon";
//
import Subscription from "../ProgramContent/ProgramHome/Subscription";
import PaymentProcess from "../ProgramContent/ProgramHome/PaymentProcess";
import { useSearchParams } from "react-router-dom";
//

function ProgramsList(props) {
  const [searchText, setSearchText] = React.useState("");
  const [showAddFolder, setShowAddFolder] = React.useState(false);
  const { state, dispatch } = React.useContext(Context);
  const [showAddProgram, setShowAddProgram] = React.useState(false);
  // const [refreshList, SetRefreshList] = React.useState(false);
  const [showJoinModal, setShowJoinModal] = React.useState(false);
  const [programUrl, setProgramUrl] = React.useState("");
  const [urlValid, setIsUrlValid] = React.useState(false);
  const [closeTour, setCloseTour] = React.useState(true);
  // const [hamburgerOpen, setHamburgerOpen] = React.useState(false);
  const [step, setStep] = React.useState(
    parseInt(getUserInfo(state).tourStepsCompleted, 10)
  );
  const StepOne = `Welcome ${getUserInfo(state).firstName} ${
    getUserInfo(state).lastName
  }, click here to create a new program.`;
  const StepTwo =
    "Click here to create a new folder that you can then add programs into.";
  const StepThree = "Click here to join an exciting mentorship program";
  const StepFour =
    "To edit/delete a folder, click the option icon and choose the action you want to perform.";

  const userdata = getUserInfo(state);

  function getPrograms() {
    dispatch(setProgramListAsLoading());
    callAPI(dispatch, "fetchPrograms").then((programs) => {
      dispatch(setProgramList(programs.data));
    });
  }
  React.useEffect(() => {
    dispatch(setProgramListAsLoading());
    getPrograms();
  }, [getProgramListRefreshToggle(state)]);

  function moveProgram(id, folder) {
    dispatch(setProgramListAsLoading());
    callAPI(dispatch, "moveProgram", {
      programId: +id,
      folderTitle: folder,
    }).then((response) => {
      getPrograms();
      // dispatch(refreshProgramList())
    });
  }
  function addFolder(name) {
    dispatch(setProgramListAsLoading());
    return callAPI(dispatch, "addFolder", { title: name });
  }

  const programs = getProgramsList(state);

  const updateSteps = () => {
    callAPI(dispatch, "updateStepCompleted", {
      id: getUserInfo(state).id,
      step: step + 1,
    });
  };

  const markTourComplete = () => {
    callAPI(dispatch, "markTourCompleted", {
      id: getUserInfo(state).id,
    }).then(() => {
      setCloseTour(false);
    });
  };

  // New Start
  const [isPremiumOpen, setIsPremiumOpen] = React.useState(false);
  const [IsPaymentOpen, setIsPaymentOpen] = React.useState(false);
  const [plan, setPlan] = React.useState("");

  const [searchParams] = useSearchParams();

  const addProgram = searchParams.get("add-program") === "yes";

  const addProgramHandler = () => {
    if (userdata?.subscription?.id && !userdata?.subscription?.programId) {
      setShowAddProgram(true);
    } else {
      setIsPremiumOpen(!isPremiumOpen);
    }
  };

  useEffect(() => {
    if (
      userdata?.subscription?.id &&
      !userdata?.subscription?.programId &&
      userdata?.subscription?.plan === "Pro" &&
      addProgram
    ) {
      setShowAddProgram(true);
    }
  }, [userdata, addProgram]);
  // New Start End

  return (
    <ProgramsListContainer hamburgerOpen={props.hamburgerOpen}>
      <CrossButtonContainer
        onClick={() => props.setHamburgerOpen(!props.hamburgerOpen)}
      >
        <CrossButtonContainerSpan></CrossButtonContainerSpan>
        <CrossButtonContainerSpan></CrossButtonContainerSpan>
      </CrossButtonContainer>

      <ProgramsListHeader>
        <HeaderLine>
          Programs
          <ListActions>
            <Buttons
              // disabled={
              //   ((planSubscribedPrograms === "Pro" ||
              //     planSubscribedPrograms === "Basic") &&
              //     numberOfPrograms >= 1) ||
              //   !userSubscription
              // }
              // onClick={() => {
              //   setShowAddProgram(true);
              // }}
              onClick={addProgramHandler}
            >
              <Image src={Add} alt="Add" />
            </Buttons>
            <Buttons onClick={() => setShowAddFolder(true)}>
              <Image src={Folder} alt="Folder" />
            </Buttons>
            <JoinButton onClick={() => setShowJoinModal(true)}>Join</JoinButton>
            {getUserInfo(state).isTourCompleted || step > 3 ? null : (
              <Tooltip
                text={step === 3 ? StepThree : step === 2 ? StepTwo : StepOne}
                step={step}
                buttonText={"Next"}
                isStep={step}
                setStep={setStep}
                onClick={updateSteps}
                onClose={markTourComplete}
              />
            )}
          </ListActions>
        </HeaderLine>
        <ViewWrapper>
          <SearchTextInput
            value={searchText}
            setValue={setSearchText}
            placeholder="Search"
          />
          <CollapseButton
            hamburgerOpen={props.hamburgerOpen}
            onClick={() => props.setHamburgerOpen(!props.hamburgerOpen)}
          >
            <Icon type={"collabs-left"} />
          </CollapseButton>
        </ViewWrapper>
      </ProgramsListHeader>

      {step === 4 && !getUserInfo(state).isTourCompleted ? (
        <SampleFolderOuter>
          <FolderDropDown>
            <Text>Sample Folder</Text>
            <FolderOptions>
              <EditDeleteOption src={EditImage} alt="Edit/Delete" />
              <OpenCloseOption src={DropdownImage} alt="Dropdown" />
            </FolderOptions>
          </FolderDropDown>
          {step === 4 && (
            <Tooltip
              text={StepFour}
              step={step}
              buttonText={"Got it!"}
              isStep={step}
              setStep={setStep}
              onClick={markTourComplete}
              onClose={markTourComplete}
            />
          )}
        </SampleFolderOuter>
      ) : null}

      <ProgramSections>
        {isProgramsListLoaded(state) &&
          Object.keys(programs)
            .filter((folder) => {
              return (
                searchText === "" ||
                programs[folder].programs.some((program) =>
                  program.title.toLowerCase().includes(searchText.toLowerCase())
                )
              );
            })
            .sort((a, b) => {
              const UpdatedAta = programs[a].createdAt;
              const UpdatedAtb = programs[b].createdAt;

              if (UpdatedAta === null && UpdatedAtb !== null) return -1;
              if (UpdatedAta !== null && UpdatedAtb === null) return 1;

              const aUpdatedAt = new Date(programs[a].createdAt || 0).getTime();
              const bUpdatedAt = new Date(programs[b].createdAt || 0).getTime();

              return bUpdatedAt - aUpdatedAt;
            })
            .map((folder) => {
              return (
                <ProgramsListSection
                  setProgramList={setProgramList}
                  moveProgram={moveProgram}
                  key={folder}
                  searchText={searchText}
                  folder={programs[folder].title}
                  programs={programs[folder]}
                  setHamburgerOpen={props.setHamburgerOpen}
                  hamburgerOpen={props.hamburgerOpen}
                  closeOnClick={props.closeOnClick}
                />
              );
            })}

        {!isProgramsListLoaded(state) && <Loading loadingItem="Programs" />}
      </ProgramSections>

      {showAddFolder && (
        <AddFolder
          addFolder={addFolder}
          closeAddFolder={() => {
            setShowAddFolder(false);
          }}
        />
      )}

      {/* New Start  */}
      {isPremiumOpen && (
        <Modal
          onClose={() => setIsPremiumOpen(false)}
          minWidth={"50vw"}
          isButtonCenter={true}
          isNotRound={true}
          isMain={true}
          hideBorder={true}
          isTask={true}
          actions={[
            {
              text: "Cancel",
              onClick: () => {
                setIsPremiumOpen(false);
              },
            },
          ]}
        >
          <Subscription
            setIsPremiumOpen={setIsPremiumOpen}
            setIsPaymentOpen={setIsPaymentOpen}
            setPlan={setPlan}
            setShowAddProgram={setShowAddProgram}
          />
        </Modal>
      )}

      {IsPaymentOpen && (
        <Modal
          isHeight={"80%"}
          isMain={true}
          onClose={() => setIsPaymentOpen(false)}
          minWidth={"50vw"}
          hideBorder={true}
          isButtonCenter={true}
          isNotRound={true}
          isTask={true}
        >
          <PaymentProcess plan={plan} />
        </Modal>
      )}

      {showAddProgram && (
        <AddProgram
          closeModal={(shouldRefresh) => {
            if (shouldRefresh) {
              dispatch(refreshProgramList());
            }
            setShowAddProgram(false);
          }}
          isMain={true}
        />
      )}
      {/* New Start End */}

      {showJoinModal && (
        <Modal
          title={"Join a program"}
          isDelete={true}
          onClose={() => setShowJoinModal(false)}
        >
          <JoinPorgramContainer>
            <Labelize label="Paste the link for the program you would like to join space below">
              <TextInput
                placeholder="Paste your link here"
                value={programUrl}
                type="text"
                isValid={validateUrl["text"]}
                validator={validateUrl}
                setValue={(newValue) => {
                  setIsUrlValid(validateUrl(newValue));
                  setProgramUrl(newValue);
                }}
              />
            </Labelize>
            <SectionActions>
              <Button
                icon={"cross"}
                variant="secondary"
                onClick={() => setShowJoinModal(false)}
                text="Cancel"
              />
              <ButtonSpacer />
              <Button
                icon="tick"
                variant="primary"
                disabled={urlValid ? false : true}
                onClick={() => (window.location.href = programUrl)}
                text="Save"
              />
            </SectionActions>
          </JoinPorgramContainer>
        </Modal>
      )}
    </ProgramsListContainer>
  );
}
export default ProgramsList;
